var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.392,
    height: 17,
    viewBox: "0 0 19.392 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_189912",
    "data-name": "Group 189912",
    transform: "translate(-124.601 -0.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189910",
    "data-name": "Group 189910",
    transform: "translate(-465.201 -590.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-star",
    "data-name": "Icon feather-star",
    d: "M11.933,3l2.76,5.592,6.173.9L16.4,13.845l1.054,6.146-5.521-2.9-5.521,2.9,1.054-6.146L3,9.494l6.173-.9Z",
    transform: "translate(588 587)",
    fill: "#e8b03e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.33ccbee5f46c3ab5ffb520be15c84277.svg";
export { ForwardRef as ReactComponent };